import React from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";

const StyledSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase": {
    padding: 4,
  },
  "& .MuiSwitch-thumb": {
    width: 16,
    height: 16,
  },
  "& .MuiSwitch-track": {
    borderRadius: 10,
  },
}));

const ContextAvailabilitySwitch = ({
  productId,
  context,
  isAvailable,
  onToggle,
}) => {
  return (
    <FormControlLabel
      control={
        <StyledSwitch
          size="small"
          checked={isAvailable}
          onChange={() => onToggle(productId, context, isAvailable)}
          color="primary"
        />
      }
      label={
        <Typography variant="body2" sx={{ fontSize: "0.75rem" }}>
          {context}: {isAvailable ? "Disponível" : "Indisponível"}
        </Typography>
      }
      sx={{ mr: 0 }}
    />
  );
};

export default ContextAvailabilitySwitch;
